import React, { Component } from 'react';
import {
  FormGroup,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import { actions, Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { Map, fromJS } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AddIcon } from '../icon/AddIcon';
import { RemoveIcon } from '../table/RemoveIcon';
import { fieldToNumber, fieldTrimmed } from './formUtilities';
import { SingleResultGrid } from '../grid/SingleResultGrid';
import { Column } from '../grid/Column';
import { Loading } from '../loadbar/Loading';
import { ResultGrid } from '../grid/ResultGrid';
import { eqVisibleColumns, eqSort, minColumns } from '../../redux/EditReduxConstant';

const resolvePublish = ({ value }) => {
  if (value == null) {
    return null;
  }
  return value ? 'Y' : 'N';
};

const defaultMap = fromJS({});

class AssociatedEarthquakeControlUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.searchEarthquakes = this.searchEarthquakes.bind(this);
    this.addEarthquake = this.addEarthquake.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.resolveRemove = this.resolveRemove.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.renderAddButton = this.renderAddButton.bind(this);
    this.state = {
      earthquakes: Map(),
      searchVisible: false,
      searchInput: '',
    };
  }

  componentDidMount() {
    const { earthquake } = this.props;
    this.setState((state) => {
      const earthquakeId = earthquake.get('id');
      const earthquakes = earthquakeId ? state.earthquakes.set(`${earthquakeId}`, earthquake) : state.earthquakes;
      return {
        earthquakes,
      };
    });
  }

  searchEarthquakes() {
    const { searchEarthquakes } = this.props;
    const { searchInput } = this.state;
    searchEarthquakes({
      queryParameters: {
        op: 'or',
        locInclude: fieldTrimmed(searchInput),
        id: fieldToNumber(searchInput),
        country: fieldTrimmed(searchInput),
        year: fieldToNumber(searchInput),
      },
    });
  }

  addEarthquake(eq) {
    const { earthquake, change, model } = this.props;
    const id = eq ? eq.get('id') : '';
    this.setState((state) => {
      const earthquakes = state.earthquakes.filter(existing => existing.get('id') === earthquake.get('id'));
      return {
        earthquakes: eq ? earthquakes.set(`${id}`, eq) : earthquakes,
      };
    }, () => {
      change(`${model}.earthquakeEventId`, `${id}`);
    });
  }

  resolveRemove({ row }) {
    if (row.get('id') == null) {
      return null;
    }
    return (<RemoveIcon handleClick={() => this.addEarthquake()} />);
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  toggleSearch() {
    this.setState(({ searchVisible: prev }) => ({ searchVisible: !prev }));
  }

  renderAddButton({ row }) {
    const { earthquakeId } = this.props;
    if (`${row.get('id')}` !== earthquakeId) {
      return (<AddIcon handleClick={() => this.addEarthquake(row)} />);
    }
    return (<div />);
  }

  render() {
    const {
      earthquakeSearching, earthquakeSearchResults, earthquakeId, sort, valid, visibleColumns,
    } = this.props;
    const { earthquakes, searchVisible, searchInput } = this.state;
    return (
      <Card>
        <CardBody>
          <CardTitle tag="h2">Associated Earthquake</CardTitle>
          <SingleResultGrid data={earthquakes.get(earthquakeId) ? earthquakes.get(earthquakeId) : defaultMap}>
            <Column id="remove" cell={this.resolveRemove} width={50}><RemoveIcon /></Column>
            <Column id="id" width={100}>ID</Column>
            <Column id="publish" cell={resolvePublish} width={85}>Publish</Column>
            <Column id="year" width={75} helpModalId="year">Year</Column>
            <Column id="month" width={50} helpModalId="month">Mo</Column>
            <Column id="day" width={50} helpModalId="day">Dy</Column>
            <Column id="hour" width={50} helpModalId="hour">Hr</Column>
            <Column id="minute" width={50} helpModalId="minute">Mn</Column>
            <Column id="second" width={75} helpModalId="second">Sec</Column>
            <Column id="locationName" width={150} helpModalId="volEarthquake">Location Name</Column>
          </SingleResultGrid>
          <div className="form-group sr-only">
            <Control type="hidden" model=".earthquakeEventId" />
          </div>
          <Errors
            model=".earthquakeEventId"
            component="div"
            wrapper={({ children }) => <div className={classnames({ 'invalid-feedback': true, 'haz-associated-table-error': !valid })}>{children}</div>}
          />

          {searchVisible ? (
            <Card>
              <CardBody>
                <CardTitle tag="h2" className="haz-close-title">
                  <span>Search</span>
                  <button type="button" className="close" aria-label="Close" onClick={this.toggleSearch}>x</button>
                </CardTitle>
                <div className="haz-assoc-search-container">
                  <div className="form-inline">
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                      <Input disabled={earthquakeSearching} value={searchInput} onChange={(e) => { this.setState({ searchInput: e.target.value }); }} type="text" />
                    </FormGroup>
                    <Button disabled={earthquakeSearching} onClick={this.searchEarthquakes}>Search</Button>
                  </div>

                  <div className="haz-assoc-search">
                    {earthquakeSearching ? (<Loading />) : (
                      <ResultGrid
                        data={earthquakeSearchResults}
                        sort={sort}
                        handleColumnsToggle={this.handleToggleColumns}
                        columnChooser
                        visibleColumns={visibleColumns}
                        defaultColumns={eqVisibleColumns}
                        defaultSort={eqSort}
                        minColumns={minColumns}
                      >
                        <Column id="add" width={50} alwaysVisible cell={this.renderAddButton}><AddIcon /></Column>
                        <Column id="id" width={100} sortable>ID</Column>
                        <Column id="publish" cell={resolvePublish} width={120} sortable>Publish</Column>
                        <Column id="year" width={100} sortable helpModalId="year">Year</Column>
                        <Column id="month" width={100} sortable helpModalId="month">Mo</Column>
                        <Column id="day" width={100} sortable helpModalId="day">Dy</Column>
                        <Column id="hour" width={100} sortable helpModalId="hour">Hr</Column>
                        <Column id="minute" width={100} sortable helpModalId="minute">Mn</Column>
                        <Column id="second" width={100} sortable helpModalId="second">Sec</Column>
                        <Column id="locationName" width={150} sortable helpModalId="volEarthquake">Location Name</Column>
                      </ResultGrid>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          ) : (<Button onClick={this.toggleSearch}>Search</Button>)}

        </CardBody>
      </Card>

    );
  }
}


AssociatedEarthquakeControlUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  earthquake: ImmutablePropTypes.map.isRequired,
  searchEarthquakes: PropTypes.func.isRequired,
  earthquakeSearching: PropTypes.bool.isRequired,
  earthquakeSearchResults: ImmutablePropTypes.list.isRequired,
  change: PropTypes.func.isRequired,
  earthquakeId: PropTypes.string.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  valid: PropTypes.bool.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,

};


const mapStateToProps = (state, { model }) => ({
  earthquakeId: state.getIn([model, 'earthquakeEventId']) ? state.getIn([model, 'earthquakeEventId']) : '',
  valid: state.get('forms')[model].earthquakeEventId.valid,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  change: actions.change,

}, dispatch);

export const AssociatedEarthquakeControl = connect(mapStateToProps, mapDispatchToProps)(AssociatedEarthquakeControlUnwrapped);
